import useAxios, { IApiResponse } from "src/core/shared/hooks/useAxios";
import { IProduct } from "src/core/products/api/products.api";

type PriceChangeApi = "GET_PRICE_CHANGE_DATES" | "GET_PRICE_CHANGE_PRODUCTS" | "ADD_ALL_PRODUCTS_TO_CHANGE_DATE";

export type PriceChangeDates = Array<{ effectiveDate: string; priceCodeId: number }>;

export type ListPriceChangeParams = {
  params: { effectiveDate: string; priceCodeId: number };
};

export type AddAllPoductsToChangeDateParams = { effectiveDate: string; priceCodeId: number };

export const priceChangeApi = <R, P = any>(name: PriceChangeApi): [IApiResponse<R, any>, <C = P>(P: C) => void] => {
  switch (name) {
    case "GET_PRICE_CHANGE_DATES":
      return useAxios<R, { priceListId: number }>(({ priceListId }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/price-change/${priceListId}/dates`,
          method: "GET"
        };
      }, name);

    case "GET_PRICE_CHANGE_PRODUCTS":
      return useAxios<R, ListPriceChangeParams>((options: ListPriceChangeParams) => {
        const pageParams = options.params;

        return {
          url: `${process.env.REACT_APP_API_URL}/price-change/${pageParams.priceCodeId}/products/${pageParams.effectiveDate}`,
          method: "GET"
        };
      }, name);

    default:
      throw new Error("priceChangeApi Requires a name parameter");
  }
};
export type PriceChangeApiType = typeof priceChangeApi;

export interface IPrice {
  id?: number;
  price: number;
  priceCodeId: number;
  productId: number;
  vatPercentage: number | null;
  vatValue: number | null;
  effectiveDate?: string | null;
  endDate?: string | null;
  minQuantity?: number;
  product?: IProduct;
}

export interface IPriceCode {
  id: number;
  code: string;
  name: string;
}

export interface IPriceList {
  id: number;
  code: string;
  name: string;
  /** RJL special price list */
  special?: boolean;
  createdAt: string;
  updatedAt: string;
}
